import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { environment } from './environments/environment';
import { getTranslationProviders } from './provider/18n.provider';
import config from 'devextreme/core/config'; 
import { licenseKey } from './devextreme-license';
 
config({ licenseKey });

if (environment.production) {
  enableProdMode();
  console.time('compile time');
}


platformBrowserDynamic()
    .bootstrapModule(AppModule, { preserveWhitespaces: true })
    .catch((err) => console.error(err));

/*
Promise
.all([getTranslationProviders()])
.then((providers: any) => {
    console.time('compile time');
    console.timeEnd('load files');
    const providerList = providers[0][0];
    const options: any = { providers : providerList, preserveWhitespaces: true };
    platformBrowserDynamic()
        .bootstrapModule(AppModule, options)
        .catch((err) => console.error(err));
});*/





